export default __webpack_public_path__ + "static/media/006-house.f0ef691f.png";